"use client";

import { useState, useEffect } from "react";
import { Box, styled } from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const Root = styled(Box)({
  padding: "12px",
});

export default function Copyright(props) {
  // Use a static year initially to avoid hydration mismatch, then update on client
  const [year, setYear] = useState(2025);

  useEffect(() => {
    // Intentional: client-only value updated after mount to avoid an SSR
    // hydration mismatch on the year.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setYear(new Date().getFullYear());
  }, []);

  return (
    <Root>
      <Typography variant="body2" color="text.secondary" align="center" sx={{ font: "var(--text-h6)", fontFamily: "var(--font-family-sans)" }} {...props}>
        {"Copyright © "}
        <Link color="inherit" href="https://floats.ai/">
          floats.ai
        </Link>{" "}
        <span suppressHydrationWarning>{year}</span>
        {"."}
      </Typography>
    </Root>
  );
}
